import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Lock, User } from 'lucide-react';
import './Login.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      
      if (response.data.success) {
        // Store token in localStorage
        localStorage.setItem('admin_token', response.data.token);
        toast.success('Connexion réussie');
        navigate('/admin');
      }
    } catch (error) {
      if (error.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error('Identifiants incorrects');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img 
            src="https://customer-assets.emergentagent.com/job_pro-service-hub-5/artifacts/w0r3tvio_APP%20ICON.png" 
            alt="ZotPro Logo" 
            className="login-logo"
          />
          <h1 className="login-title">Administration ZotPro</h1>
          <p className="login-subtitle">Connectez-vous pour accéder au tableau de bord</p>
        </div>

        <Card className="login-card">
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-field">
              <Label htmlFor="username">
                <User size={18} className="field-icon" />
                Nom d'utilisateur
              </Label>
              <Input
                id="username"
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                placeholder="admin"
                required
                autoComplete="username"
              />
            </div>

            <div className="form-field">
              <Label htmlFor="password">
                <Lock size={18} className="field-icon" />
                Mot de passe
              </Label>
              <Input
                id="password"
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                placeholder="••••••••"
                required
                autoComplete="current-password"
              />
            </div>

            <Button type="submit" className="login-btn" disabled={loading}>
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>
        </Card>

        <div className="login-footer">
          <a href="/" className="back-link">← Retour à la page d'accueil</a>
        </div>
      </div>
    </div>
  );
};

export default Login;
